import React from "react"
import { AuthProvider } from "./src/context/AuthContext"
import "./src/assets/scss/main.global.scss"
import "react-toastify/dist/ReactToastify.css"

export const wrapPageElement = ({ element }) => (
  <AuthProvider>{element}</AuthProvider>
)
